import { useState } from "react";
import { isDeepEqual } from "react-use/lib/util";

export const useApplicableState = <TState>(initialState: TState) => {
    const [_initState, _setInitState] = useState<TState>(initialState);
    const [state, _setState] = useState<TState>(initialState);

    const [hasChanged, _setHasChanged] = useState(false);

    const setState = (newState: TState) => {
        _setState(newState);
        _setHasChanged(!isDeepEqual(_initState, newState));
    };

    /* the only use case of passing newState is when initialization of this hook's state is
        deferred until useEffect fires; in such case state set by setState() wouldn't be
        visible for apply() in the same render */
    const apply = (newState?: TState) => {
        _setInitState(newState ?? state);
        _setHasChanged(false);
    };

    return [state, setState, apply, hasChanged] as const;
};
